import { Product } from '../types';

// ============================================
// TERMINAL CAPS & PLASTIC COMPONENTS
// ============================================

// DIP MOULDING TERMINAL CAPS - BULLET/BLADE SERIES (per catalog: CB/CA/CW order)
export const terminalCapProducts: Product[] = [
  {
    id: "tcap-cb-103",
    name: "CB-103 Terminal Cap",
    slug: "terminal-cap-cb-103",
    category: "Terminal Caps",
    subcategory: "Bullet Series Caps",
    description: "Terminal cap for bullet terminals. CB-103 series.",
    partNumber: "SI0007001",
    image: "/products/terminal-caps/caps/SI0007001.jpg",
    specifications: {
      "Series": "CB-103",
      "Dimensions": "25.00mm x 4.50mm",
      "Type": "Standard Cap",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "bullet", "cb-103"],
    applications: ["Automotive", "Terminal Protection"],
  },
  {
    id: "tcap-ca-103",
    name: "CA-103 Terminal Cap",
    slug: "terminal-cap-ca-103",
    category: "Terminal Caps",
    subcategory: "Bullet Series Caps",
    description: "Terminal cap for bullet terminals. CA-103 series.",
    partNumber: "SI0007002",
    image: "/products/terminal-caps/caps/SI0007002.jpg",
    specifications: {
      "Series": "CA-103",
      "Dimensions": "20.00mm x 4.00mm",
      "Type": "Standard Cap",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "bullet", "ca-103"],
    applications: ["Automotive", "Terminal Protection"],
  },
  {
    id: "tcap-cb-104",
    name: "CB-104 Terminal Cap",
    slug: "terminal-cap-cb-104",
    category: "Terminal Caps",
    subcategory: "Bullet Series Caps",
    description: "Terminal cap for bullet terminals. CB-104 series.",
    partNumber: "SI0007003",
    image: "/products/terminal-caps/caps/SI0007003.jpg",
    specifications: {
      "Series": "CB-104",
      "Dimensions": "28.00mm x 5.50mm",
      "Type": "Standard Cap",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "bullet", "cb-104"],
    applications: ["Automotive", "Terminal Protection"],
  },
  {
    id: "tcap-ca-104",
    name: "CA-104 Terminal Cap",
    slug: "terminal-cap-ca-104",
    category: "Terminal Caps",
    subcategory: "Bullet Series Caps",
    description: "Terminal cap for bullet terminals. CA-104 series.",
    partNumber: "SI0007004",
    image: "/products/terminal-caps/caps/SI0007004.jpg",
    specifications: {
      "Series": "CA-104",
      "Dimensions": "21.00mm x 4.30mm",
      "Type": "Standard Cap",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "bullet", "ca-104"],
    applications: ["Automotive", "Terminal Protection"],
  },
  {
    id: "tcap-cw-103",
    name: "CW-103 Terminal Cap",
    slug: "terminal-cap-cw-103",
    category: "Terminal Caps",
    subcategory: "Bullet Series Caps",
    description: "Waterproof terminal cap for bullet terminals. CW-103 series.",
    partNumber: "SI0007005",
    image: "/products/terminal-caps/caps/SI0007005.jpg",
    specifications: {
      "Series": "CW-103",
      "Dimensions": "33.20mm x 9.00mm",
      "Type": "Waterproof Cap",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "waterproof", "bullet", "cw-103"],
    applications: ["Automotive", "Waterproof Connections"],
  },
  {
    id: "tcap-cw-104",
    name: "CW-104 Terminal Cap",
    slug: "terminal-cap-cw-104",
    category: "Terminal Caps",
    subcategory: "Bullet Series Caps",
    description: "Waterproof terminal cap for bullet terminals. CW-104 series.",
    partNumber: "SI0007006",
    image: "/products/terminal-caps/caps/SI0007006.jpg",
    specifications: {
      "Series": "CW-104",
      "Dimensions": "35.18mm x 9.10mm",
      "Type": "Waterproof Cap",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "waterproof", "bullet", "cw-104"],
    applications: ["Automotive", "Waterproof Connections"],
  },
];

// 0250 SERIES TERMINAL CAPS
export const terminal0250CapProducts: Product[] = [
  {
    id: "tcap-0250-6.4f-slot",
    name: "0250 Series - 6.4 Female Slot Terminal Cap",
    slug: "terminal-cap-0250-6.4-female-slot",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "Terminal cap for 0250 series 6.4mm female slot terminals.",
    partNumber: "SI0025001",
    image: "/products/terminal-caps/caps/SI0025001.jpg",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "Female Slot",
      "Tab Size": "6.4mm",
      "Dimensions": "26.00mm x 8.40mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "female", "slot"],
    applications: ["Automotive", "0250 Terminals"],
  },
  {
    id: "tcap-0250-6.4f-slot-pbc",
    name: "0250 Series - 6.4 Female Slot Terminal Cap (P.B.C)",
    slug: "terminal-cap-0250-6.4-female-slot-pbc",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "Terminal cap for 0250 series 6.4mm female slot terminals. PBC material for better durability.",
    partNumber: "SI0025002",
    image: "/products/terminal-caps/caps/SI0025002.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "Female Slot (P.B.C)",
      "Tab Size": "6.4mm",
      "Dimensions": "23.00mm x 8.10mm",
      "Material": "PBC",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "female", "slot", "pbc"],
    applications: ["Automotive", "0250 Terminals"],
  },
  {
    id: "tcap-0250-6.4f-flag",
    name: "0250 Series - 6.4 Female Flag Terminal Cap",
    slug: "terminal-cap-0250-6.4-female-flag",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "Terminal cap for 0250 series 6.4mm female flag terminals.",
    partNumber: "SI0025025",
    image: "/products/terminal-caps/caps/SI0025025.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "Female Flag",
      "Tab Size": "6.4mm",
      "Dimensions": "22.00mm x 8.40mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "female", "flag"],
    applications: ["Automotive", "0250 Terminals"],
  },
  {
    id: "tcap-0250-3pole",
    name: "0250 Series - 3 Pole Coupler Cap",
    slug: "terminal-cap-0250-3-pole-coupler",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "3 pole coupler cap for 0250 series terminals.",
    partNumber: "SI0025003",
    image: "/products/terminal-caps/caps/SI0025003.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "3 Pole Coupler",
      "Dimensions": "36.00mm x 24.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "coupler", "3-pole"],
    applications: ["Automotive", "Multi-Pole Connectors"],
  },
  {
    id: "tcap-0250-4pole",
    name: "0250 Series - 4 Pole Coupler Cap",
    slug: "terminal-cap-0250-4-pole-coupler",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "4 pole coupler cap for 0250 series terminals.",
    partNumber: "SI0025004",
    image: "/products/terminal-caps/caps/SI0025004.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "4 Pole Coupler",
      "Dimensions": "38.00mm x 27.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "coupler", "4-pole"],
    applications: ["Automotive", "Multi-Pole Connectors"],
  },
  {
    id: "tcap-0250-6pole-f",
    name: "0250 Series - 6 Pole Female Coupler Cap",
    slug: "terminal-cap-0250-6-pole-female-coupler",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "6 pole female coupler cap for 0250 series terminals.",
    partNumber: "SI0025006F",
    image: "/products/terminal-caps/caps/SI0025006F.jpg",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "6 Pole Female Coupler",
      "Dimensions": "40.00mm x 29.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "coupler", "6-pole", "female"],
    applications: ["Automotive", "Multi-Pole Connectors"],
  },
  {
    id: "tcap-0250-6pole-m",
    name: "0250 Series - 6 Pole Male Coupler Cap",
    slug: "terminal-cap-0250-6-pole-male-coupler",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "6 pole male coupler cap for 0250 series terminals.",
    partNumber: "SI0025006M",
    image: "/products/terminal-caps/caps/SI0025006M.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "6 Pole Male Coupler",
      "Dimensions": "42.00mm x 30.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "coupler", "6-pole", "male"],
    applications: ["Automotive", "Multi-Pole Connectors"],
  },
  {
    id: "tcap-0250-8pole-f",
    name: "0250 Series - 8 Pole Female Coupler Cap",
    slug: "terminal-cap-0250-8-pole-female-coupler",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "8 pole female coupler cap for 0250 series terminals.",
    partNumber: "SI0025008F",
    image: "/products/terminal-caps/caps/SI0025008F.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "8 Pole Female Coupler",
      "Dimensions": "59.00mm x 44.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "coupler", "8-pole", "female"],
    applications: ["Automotive", "Multi-Pole Connectors"],
  },
  {
    id: "tcap-0250-8pole-m",
    name: "0250 Series - 8 Pole Male Coupler Cap",
    slug: "terminal-cap-0250-8-pole-male-coupler",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "8 pole male coupler cap for 0250 series terminals.",
    partNumber: "SI0025008M",
    image: "/products/terminal-caps/caps/SI0025008M.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "8 Pole Male Coupler",
      "Dimensions": "61.00mm x 45.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "coupler", "8-pole", "male"],
    applications: ["Automotive", "Multi-Pole Connectors"],
  },
  {
    id: "tcap-0250-8pole-hazard-f",
    name: "0250 Series - 8 Pole Hazard Female Coupler Cap",
    slug: "terminal-cap-0250-8-pole-hazard-female",
    category: "Terminal Caps",
    subcategory: "0250 Series Caps",
    description: "8 pole hazard female coupler cap for 0250 series terminals. Special design for hazard light circuits.",
    partNumber: "SI0025010",
    image: "/products/terminal-caps/caps/SI0025010.jpg",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Type": "8 Pole Hazard Female Coupler",
      "Dimensions": "40.00mm x 32.00mm",
      "Application": "Hazard Lights",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0250", "coupler", "8-pole", "hazard"],
    applications: ["Automotive", "Hazard Lights"],
  },
];

// 0312 SERIES TERMINAL CAPS
export const terminal0312CapProducts: Product[] = [
  {
    id: "tcap-0312-8.3f-flag",
    name: "0312 Series - 8.3 Female Flag Terminal Cap",
    slug: "terminal-cap-0312-8.3-female-flag",
    category: "Terminal Caps",
    subcategory: "0312 Series Caps",
    description: "Terminal cap for 0312 series 8.3mm female flag terminals.",
    partNumber: "SI0031201",
    image: "/products/terminal-caps/caps/SI0031201.jpg",
    specifications: {
      "Series": "0312 (7.8mm)",
      "Type": "Female Flag",
      "Tab Size": "8.3mm",
      "Dimensions": "26.00mm x 9.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0312", "female", "flag"],
    applications: ["Automotive", "0312 Terminals"],
  },
  {
    id: "tcap-0312-3pole-headlight",
    name: "0312 Series - 3 Pole Female Head Light Coupler Cap",
    slug: "terminal-cap-0312-3-pole-headlight",
    category: "Terminal Caps",
    subcategory: "0312 Series Caps",
    description: "3 pole female headlight coupler cap for 0312 series terminals.",
    partNumber: "SI0031205",
    image: "/products/terminal-caps/caps/SI0031205.jpg",
    featured: true,
    specifications: {
      "Series": "0312 (7.8mm)",
      "Type": "3 Pole Female Headlight Coupler",
      "Dimensions": "36.00mm x 23.00mm",
      "Application": "Headlight",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0312", "coupler", "headlight", "3-pole"],
    applications: ["Automotive", "Headlight Connections"],
  },
];

// 0110 AND 0187 SERIES TERMINAL CAPS
export const terminal0110_0187CapProducts: Product[] = [
  {
    id: "tcap-0110-3.2f-lock",
    name: "3.2 Female Lock Terminal Cap",
    slug: "terminal-cap-0110-3.2-female-lock",
    category: "Terminal Caps",
    subcategory: "0110 Series Caps",
    description: "Terminal cap for 3.2mm female lock terminals.",
    partNumber: "SI0011001",
    image: "/products/terminal-caps/caps/SI0011001.jpg",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Type": "Female Lock",
      "Tab Size": "3.2mm",
      "Dimensions": "20.00mm x 3.50mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0110", "female", "lock"],
    applications: ["Automotive", "0110 Terminals"],
  },
  {
    id: "tcap-0187-4.8f-slot",
    name: "4.8 Female Slot Terminal Cap",
    slug: "terminal-cap-0187-4.8-female-slot",
    category: "Terminal Caps",
    subcategory: "0187 Series Caps",
    description: "Terminal cap for 4.8mm female slot terminals.",
    partNumber: "SI0018001",
    image: "/products/terminal-caps/caps/SI0018001.jpg",
    specifications: {
      "Series": "0187 (4.8mm)",
      "Type": "Female Slot",
      "Tab Size": "4.8mm",
      "Dimensions": "25.00mm x 5.40mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "0187", "female", "slot"],
    applications: ["Automotive", "0187 Terminals"],
  },
  {
    id: "tcap-0031201",
    name: "Terminal Cap - 3.2 Female Lock",
    slug: "terminal-cap-3.2-female-lock",
    category: "Terminal Caps",
    subcategory: "Special Caps",
    description: "Terminal cap for 3.2mm female lock terminals.",
    partNumber: "SI0031201",
    image: "/products/terminal-caps/caps/SI0031201.jpg",
    specifications: {
      "Type": "Female Lock",
      "Tab Size": "3.2mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "female", "lock"],
    applications: ["Automotive", "Terminal Protection"],
  },
  {
    id: "tcap-0031205",
    name: "Terminal Cap - 4.8 Female Slot",
    slug: "terminal-cap-4.8-female-slot",
    category: "Terminal Caps",
    subcategory: "Special Caps",
    description: "Terminal cap for 4.8mm female slot terminals.",
    partNumber: "SI0031205",
    image: "/products/terminal-caps/caps/SI0031205.jpg",
    specifications: {
      "Type": "Female Slot",
      "Tab Size": "4.8mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "female", "slot"],
    applications: ["Automotive", "Terminal Protection"],
  },
];

// VEHICLE-SPECIFIC TERMINAL CAPS
export const vehicleSpecificCapProducts: Product[] = [
  {
    id: "tcap-6.4-positive-lock-pvc",
    name: "6.4 Positive Lock Terminal Cap (P.V.C.)",
    slug: "terminal-cap-6.4-positive-lock-pvc",
    category: "Terminal Caps",
    subcategory: "Special Caps",
    description: "6.4mm positive lock terminal cap. PVC material.",
    partNumber: "SI0099001",
    image: "/products/terminal-caps/caps/SI0099001.jpg",
    featured: true,
    specifications: {
      "Type": "Positive Lock",
      "Material": "PVC",
      "Tab Size": "6.4mm",
      "Dimensions": "24.00mm x 8.40mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "positive-lock", "pvc"],
    applications: ["Automotive", "Positive Lock Terminals"],
  },
  {
    id: "tcap-6.4-positive-lock-pbc-2pole",
    name: "6.4 Positive Lock 2 Pole Terminal Cap (P.B.C.)",
    slug: "terminal-cap-6.4-positive-lock-pbc-2pole",
    category: "Terminal Caps",
    subcategory: "Special Caps",
    description: "6.4mm positive lock 2 pole terminal cap. PBC material.",
    partNumber: "SI0099002",
    image: "/products/terminal-caps/caps/SI0099002.jpg",
    specifications: {
      "Type": "Positive Lock 2 Pole",
      "Material": "PBC",
      "Tab Size": "6.4mm",
      "Dimensions": "24.00mm x 8.40mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "positive-lock", "pbc", "2-pole"],
    applications: ["Automotive", "Positive Lock Terminals"],
  },
  {
    id: "tcap-battery-la204-206",
    name: "Terminal Cap - LA-204 & LA-206",
    slug: "terminal-cap-la-204-206",
    category: "Terminal Caps",
    subcategory: "Battery Terminal Caps",
    description: "Terminal cap for LA-204 and LA-206 battery lugs.",
    partNumber: "SI0099010",
    image: "/products/terminal-caps/caps/SI0099010.jpg",
    specifications: {
      "Compatible": "LA-204, LA-206",
      "Dimensions": "30.00mm x 26.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "lugs"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "tcap-battery-la306",
    name: "Terminal Cap - LA-306",
    slug: "terminal-cap-la-306",
    category: "Terminal Caps",
    subcategory: "Battery Terminal Caps",
    description: "Terminal cap for LA-306 battery lugs.",
    partNumber: "SI0099011",
    image: "/products/terminal-caps/caps/SI0099011.jpg",
    specifications: {
      "Compatible": "LA-306",
      "Dimensions": "30.00mm x 28.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "lugs"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "tcap-ring-la206-208-210",
    name: "Ring Terminal Cap - LA-206, 208, 210",
    slug: "ring-terminal-cap-la-206-208-210",
    category: "Terminal Caps",
    subcategory: "Ring Terminal Caps",
    description: "Terminal cap for ring terminals LA-206, LA-208, and LA-210.",
    partNumber: "SI0099116",
    image: "/products/terminal-caps/caps/SI0099116.jpg",
    specifications: {
      "Compatible": "LA-206, LA-208, LA-210",
      "Type": "Ring Terminal",
      "Dimensions": "25.00mm x 18.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "ring", "la-series"],
    applications: ["Automotive", "Ring Terminals"],
  },
  {
    id: "tcap-ring-la306-308-310",
    name: "Ring Terminal Cap - LA-306, 308, 310",
    slug: "ring-terminal-cap-la-306-308-310",
    category: "Terminal Caps",
    subcategory: "Ring Terminal Caps",
    description: "Terminal cap for ring terminals LA-306, LA-308, and LA-310.",
    partNumber: "SI0099118",
    image: "/products/terminal-caps/caps/SI0099118.jpg",
    specifications: {
      "Compatible": "LA-306, LA-308, LA-310",
      "Type": "Ring Terminal",
      "Dimensions": "25.00mm x 18.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "ring", "la-series"],
    applications: ["Automotive", "Ring Terminals"],
  },
  {
    id: "tcap-maruti-car-lugs",
    name: "Battery Lugs Cap - Maruti Car Type",
    slug: "battery-lugs-cap-maruti-car",
    category: "Terminal Caps",
    subcategory: "Vehicle-Specific Caps",
    description: "Suitable for Maruti car type battery lugs cap.",
    partNumber: "SI0099015",
    image: "/products/terminal-caps/caps/SI0099015.jpg",
    featured: true,
    specifications: {
      "Compatible": "Maruti Car",
      "Type": "Battery Lugs Cap",
      "Dimensions": "42.00mm x 23.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "maruti", "car"],
    applications: ["Maruti Cars", "Battery Protection"],
  },
  {
    id: "tcap-tata-ace-lugs",
    name: "Battery Lugs Cap - Tata ACE",
    slug: "battery-lugs-cap-tata-ace",
    category: "Terminal Caps",
    subcategory: "Vehicle-Specific Caps",
    description: "Suitable for Tata ACE battery lugs cap.",
    partNumber: "SI0099021",
    image: "/products/terminal-caps/caps/SI0099021.jpg",
    specifications: {
      "Compatible": "Tata ACE",
      "Type": "Battery Lugs Cap",
      "Dimensions": "35.00mm x 57.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "tata", "ace"],
    applications: ["Tata ACE", "Battery Protection"],
  },
  {
    id: "tcap-battery-terminal-general",
    name: "Battery Terminal Cap",
    slug: "battery-terminal-cap-general",
    category: "Terminal Caps",
    subcategory: "Battery Terminal Caps",
    description: "Suitable for battery terminal cap. Red and black pair for battery posts.",
    partNumber: "SI0099031",
    image: "/products/terminal-caps/caps/SI0099031.jpg",
    specifications: {
      "Type": "Battery Terminal Cap",
      "Dimensions": "28.50mm x 58.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "universal"],
    applications: ["Automotive", "Battery Protection"],
  },
  {
    id: "tcap-2w-battery-terminal",
    name: "2 Wheeler Battery Terminal Cap",
    slug: "battery-terminal-cap-2wheeler",
    category: "Terminal Caps",
    subcategory: "Battery Terminal Caps",
    description: "Suitable for 2 wheeler battery terminal cap.",
    partNumber: "SI0099107",
    image: "/products/terminal-caps/caps/SI0099107.jpg",
    specifications: {
      "Compatible": "2 Wheeler",
      "Type": "Battery Terminal Cap",
      "Dimensions": "32.60mm x 18.40mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "2-wheeler"],
    applications: ["Motorcycles", "Scooters", "Battery Protection"],
  },
  {
    id: "tcap-tata-sumo-small",
    name: "Battery Lugs Cap - Tata Sumo (Small)",
    slug: "battery-lugs-cap-tata-sumo-small",
    category: "Terminal Caps",
    subcategory: "Vehicle-Specific Caps",
    description: "Battery lugs cap for Tata Sumo old and new models. Small size.",
    partNumber: "SI0099064",
    image: "/products/terminal-caps/caps/SI0099064.jpg",
    specifications: {
      "Compatible": "Tata Sumo Old & New",
      "Size": "Small",
      "Dimensions": "75.00mm x 25.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "tata", "sumo"],
    applications: ["Tata Sumo", "Battery Protection"],
  },
  {
    id: "tcap-tata-sumo-big",
    name: "Battery Lugs Cap - Tata Sumo (Big)",
    slug: "battery-lugs-cap-tata-sumo-big",
    category: "Terminal Caps",
    subcategory: "Vehicle-Specific Caps",
    description: "Battery lugs cap for Tata Sumo old and new models. Big size.",
    partNumber: "SI0099124",
    image: "/products/terminal-caps/caps/SI0099124.jpg",
    specifications: {
      "Compatible": "Tata Sumo Old & New",
      "Size": "Big",
      "Dimensions": "90.00mm x 50.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "tata", "sumo"],
    applications: ["Tata Sumo", "Battery Protection"],
  },
];

// 2-WHEELER HOUSING CAPS (part numbers per catalog)
export const twoWheelerHousingCapProducts: Product[] = [
  {
    id: "tcap-2w-bajaj-pulsar",
    name: "Bajaj Pulsar Housing Cap",
    slug: "housing-cap-bajaj-pulsar",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for Bajaj Pulsar housing cap.",
    partNumber: "SI0099035",
    image: "/products/terminal-caps/caps/SI0099035.jpg",
    featured: true,
    specifications: {
      "Compatible": "Bajaj Pulsar",
      "Type": "Housing Cap",
      "Dimensions": "84.50mm x 49.60mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "bajaj", "pulsar", "2-wheeler"],
    applications: ["Bajaj Pulsar", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-hero-hf-delux",
    name: "Hero HF Delux Housing Cap",
    slug: "housing-cap-hero-hf-delux",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for Hero HF Delux housing cap.",
    partNumber: "SI0099049",
    image: "/products/terminal-caps/caps/SI0099049.jpg",
    specifications: {
      "Compatible": "Hero HF Delux",
      "Type": "Housing Cap",
      "Dimensions": "87.75mm x 40.80mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "hero", "hf-delux", "2-wheeler"],
    applications: ["Hero HF Delux", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-honda-activa",
    name: "Honda Activa Housing Cap",
    slug: "housing-cap-honda-activa",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for Honda Activa housing cap.",
    partNumber: "SI0099053",
    image: "/products/terminal-caps/caps/SI0099053.jpg",
    featured: true,
    specifications: {
      "Compatible": "Honda Activa",
      "Type": "Housing Cap",
      "Dimensions": "81.00mm x 35.50mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "honda", "activa", "2-wheeler"],
    applications: ["Honda Activa", "Scooter Wiring"],
  },
  {
    id: "tcap-2w-tvs",
    name: "TVS Housing Cap",
    slug: "housing-cap-tvs",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for TVS housing cap.",
    partNumber: "SI0099058",
    image: "/products/terminal-caps/caps/SI0099058.jpg",
    specifications: {
      "Compatible": "TVS",
      "Type": "Housing Cap",
      "Dimensions": "51.50mm x 30.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "tvs", "2-wheeler"],
    applications: ["TVS Motorcycles", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-tvs-type2",
    name: "TVS Housing Cap Type-II",
    slug: "housing-cap-tvs-type2",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for TVS housing cap Type-II.",
    partNumber: "SI0099061",
    image: "/products/terminal-caps/caps/SI0099061.jpg",
    specifications: {
      "Compatible": "TVS",
      "Type": "Housing Cap Type-II",
      "Dimensions": "50.30mm x 31.60mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "tvs", "type-2", "2-wheeler"],
    applications: ["TVS Motorcycles", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-bajaj-pulsar-new",
    name: "Bajaj Pulsar New Model Housing Cap",
    slug: "housing-cap-bajaj-pulsar-new",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for Bajaj Pulsar new model housing cap.",
    partNumber: "SI0099045",
    image: "/products/terminal-caps/caps/SI0099045.jpg",
    specifications: {
      "Compatible": "Bajaj Pulsar New Model",
      "Type": "Housing Cap",
      "Dimensions": "103.00mm x 68.20mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "bajaj", "pulsar", "new-model", "2-wheeler"],
    applications: ["Bajaj Pulsar", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-bajaj-discover",
    name: "Bajaj Discover Housing Cap",
    slug: "housing-cap-bajaj-discover",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for Bajaj Discover housing cap.",
    partNumber: "SI0099038",
    image: "/products/terminal-caps/caps/SI0099038.jpg",
    specifications: {
      "Compatible": "Bajaj Discover",
      "Type": "Housing Cap",
      "Dimensions": "100.00mm x 36.30mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "bajaj", "discover", "2-wheeler"],
    applications: ["Bajaj Discover", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-honda",
    name: "Honda Housing Cap",
    slug: "housing-cap-honda",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for Honda housing cap.",
    partNumber: "SI0099043",
    image: "/products/terminal-caps/caps/SI0099043.jpg",
    specifications: {
      "Compatible": "Honda",
      "Type": "Housing Cap",
      "Dimensions": "90.20mm x 50.20mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "honda", "2-wheeler"],
    applications: ["Honda Motorcycles", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-bajaj-general",
    name: "Bajaj Housing Cap",
    slug: "housing-cap-bajaj",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for Bajaj housing cap.",
    partNumber: "SI0099070",
    image: "/products/terminal-caps/caps/SI0099070.jpg",
    specifications: {
      "Compatible": "Bajaj",
      "Type": "Housing Cap",
      "Dimensions": "33.18mm x 35.05mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "bajaj", "2-wheeler"],
    applications: ["Bajaj Motorcycles", "Motorcycle Wiring"],
  },
  {
    id: "tcap-2w-general",
    name: "2 Wheeler Housing Cap - General",
    slug: "housing-cap-2wheeler-general",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099072",
    image: "/products/terminal-caps/caps/SI0099072.jpg",
    featured: true,
    specifications: {
      "Compatible": "Universal 2 Wheeler",
      "Type": "Housing Cap",
      "Dimensions": "60.00mm x 45.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "universal", "2-wheeler"],
    applications: ["Motorcycles", "Universal Wiring"],
  },
  {
    id: "tcap-2w-terminal-general",
    name: "2 Wheeler Terminal Cap - General",
    slug: "terminal-cap-2wheeler-general",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099074",
    image: "/products/terminal-caps/caps/SI0099074.jpg",
    specifications: {
      "Compatible": "Universal 2 Wheeler",
      "Type": "Terminal Cap",
      "Dimensions": "40.00mm x 18.85mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "universal", "2-wheeler"],
    applications: ["Motorcycles", "Universal Wiring"],
  },
  // DIP Moulding 2 Wheeler Housing / Terminal Caps (catalog SI0099076–SI0099114)
  {
    id: "tcap-2w-housing-si0099076",
    name: "2 Wheeler Housing Cap",
    slug: "2w-housing-cap-si0099076",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099076",
    image: "/products/terminal-caps/caps/SI0099076.jpg",
    specifications: { "Dimensions": "50.00mm x 17.20mm", "Packing": "100 Pcs" },
    tags: ["housing-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-housing-si0099078",
    name: "2 Wheeler Housing Cap",
    slug: "2w-housing-cap-si0099078",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099078",
    image: "/products/terminal-caps/caps/SI0099078.jpg",
    specifications: { "Dimensions": "50.20mm x 29.60mm", "Packing": "100 Pcs" },
    tags: ["housing-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-housing-si0099080",
    name: "2 Wheeler Housing Cap",
    slug: "2w-housing-cap-si0099080",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099080",
    image: "/products/terminal-caps/caps/SI0099080.jpg",
    specifications: { "Dimensions": "73.15mm x 24.20mm", "Packing": "100 Pcs" },
    tags: ["housing-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099082",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099082",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099082",
    image: "/products/terminal-caps/caps/SI0099082.jpg",
    specifications: { "Dimensions": "46.00mm x 19.62mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-housing-si0099084",
    name: "2 Wheeler Housing Cap",
    slug: "2w-housing-cap-si0099084",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099084",
    image: "/products/terminal-caps/caps/SI0099084.jpg",
    specifications: { "Dimensions": "22.30mm x 20.30mm", "Packing": "100 Pcs" },
    tags: ["housing-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099086",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099086",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099086",
    image: "/products/terminal-caps/caps/SI0099086.jpg",
    specifications: { "Dimensions": "38.45mm x 10.00mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099088",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099088",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099088",
    image: "/products/terminal-caps/caps/SI0099088.jpg",
    specifications: { "Dimensions": "35.65mm x 9.32mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099090",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099090",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099090",
    image: "/products/terminal-caps/caps/SI0099090.jpg",
    specifications: { "Dimensions": "32.35mm x 13.70mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099092",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099092",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099092",
    image: "/products/terminal-caps/caps/SI0099092.jpg",
    specifications: { "Dimensions": "36.35mm x 10.15mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099096",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099096",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099096",
    image: "/products/terminal-caps/caps/SI0099096.jpg",
    specifications: { "Dimensions": "20.00mm x 10.00mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-housing-si0099098",
    name: "2 Wheeler Housing Cap",
    slug: "2w-housing-cap-si0099098",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099098",
    image: "/products/terminal-caps/caps/SI0099098.jpg",
    specifications: { "Dimensions": "28.30mm x 15.80mm", "Packing": "100 Pcs" },
    tags: ["housing-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099100",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099100",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099100",
    image: "/products/terminal-caps/caps/SI0099100.jpg",
    specifications: { "Dimensions": "37.50mm x 10.00mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099105",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099105",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099105",
    image: "/products/terminal-caps/caps/SI0099105.jpg",
    specifications: { "Dimensions": "39.00mm x 10.38mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-housing-si0099110",
    name: "2 Wheeler Housing Cap",
    slug: "2w-housing-cap-si0099110",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099110",
    image: "/products/terminal-caps/caps/SI0099110.jpg",
    specifications: { "Dimensions": "33.60mm x 20.00mm", "Packing": "100 Pcs" },
    tags: ["housing-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-terminal-si0099112",
    name: "2 Wheeler Terminal Cap",
    slug: "2w-terminal-cap-si0099112",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Terminal Caps",
    description: "Suitable for 2 wheeler terminal cap.",
    partNumber: "SI0099112",
    image: "/products/terminal-caps/caps/SI0099112.jpg",
    specifications: { "Dimensions": "35.06mm x 10.15mm", "Packing": "100 Pcs" },
    tags: ["terminal-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "tcap-2w-housing-si0099114",
    name: "2 Wheeler Housing Cap",
    slug: "2w-housing-cap-si0099114",
    category: "Terminal Caps",
    subcategory: "2-Wheeler Housing Caps",
    description: "Suitable for 2 wheeler housing cap.",
    partNumber: "SI0099114",
    image: "/products/terminal-caps/caps/SI0099114.jpg",
    specifications: { "Dimensions": "47.20mm x 28.00mm", "Packing": "100 Pcs" },
    tags: ["housing-cap", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
];

// 3-WHEELER AND 4-WHEELER CAPS
export const multiWheelerCapProducts: Product[] = [
  {
    id: "tcap-3w-mahindra-maximo",
    name: "Mahindra Maxximo Housing Cap",
    slug: "housing-cap-mahindra-maximo",
    category: "Terminal Caps",
    subcategory: "3-Wheeler Caps",
    description: "Suitable for Mahindra Maxximo housing cap.",
    partNumber: "SI0099047",
    image: "/products/terminal-caps/caps/SI0099047.jpg",
    specifications: {
      "Compatible": "Mahindra Maxximo",
      "Type": "Housing Cap",
      "Dimensions": "101.18mm x 68.80mm",
      "Packing": "100 Pcs",
    },
    tags: ["housing-cap", "mahindra", "maxximo", "3-wheeler"],
    applications: ["Mahindra Maxximo", "3-Wheeler Wiring"],
  },
  {
    id: "tcap-3w-battery-terminal",
    name: "3 Wheeler Battery Terminal Cap",
    slug: "battery-terminal-cap-3wheeler",
    category: "Terminal Caps",
    subcategory: "3-Wheeler Caps",
    description: "Battery terminal cap for 3-wheeler auto-rickshaw battery connections.",
    partNumber: "SI0099103",
    image: "/products/terminal-caps/caps/SI0099103.jpg",
    specifications: {
      "Compatible": "3 Wheeler",
      "Type": "Battery Terminal Cap",
      "Dimensions": "47.00mm",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "3-wheeler", "auto-rickshaw"],
    applications: ["3-Wheeler", "Battery Protection"],
  },
  {
    id: "tcap-4w-4pole-connector",
    name: "4 Pole Round Connector Cap",
    slug: "connector-cap-4-pole-round",
    category: "Terminal Caps",
    subcategory: "Connector Caps",
    description: "4 pole round connector cap for 4-wheeler automotive applications.",
    partNumber: "SI0099119",
    image: "/products/terminal-caps/caps/SI0099119.jpg",
    specifications: {
      "Type": "4 Pole Round Connector Cap",
      "Poles": "4",
      "Packing": "100 Pcs",
    },
    tags: ["connector-cap", "4-pole", "round", "4-wheeler"],
    applications: ["Automotive", "4-Pole Connectors"],
  },
  {
    id: "tcap-battery-terminal-4w",
    name: "Battery Terminal Cap - 4 Wheeler",
    slug: "battery-terminal-cap-4wheeler",
    category: "Terminal Caps",
    subcategory: "Battery Terminal Caps",
    description: "Battery terminal cap for 4-wheeler automotive battery connections.",
    partNumber: "SI0099121",
    image: "/products/terminal-caps/caps/SI0099121.jpg",
    specifications: {
      "Compatible": "4 Wheeler",
      "Type": "Battery Terminal Cap",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "battery", "4-wheeler"],
    applications: ["4-Wheeler", "Battery Protection"],
  },
  {
    id: "tcap-general-terminal",
    name: "General Terminal Cap",
    slug: "terminal-cap-general",
    category: "Terminal Caps",
    subcategory: "Universal Caps",
    description: "Universal general purpose terminal cap for various applications.",
    partNumber: "SI0099123",
    image: "/products/terminal-caps/caps/SI0099123.jpg",
    specifications: {
      "Type": "General Terminal Cap",
      "Application": "Universal",
      "Packing": "100 Pcs",
    },
    tags: ["terminal-cap", "universal", "general"],
    applications: ["Automotive", "Universal Applications"],
  },
];
